module.exports = __webpack_public_path__ + "img/arrow-left.1fd4473a.svg";